import { DataTableColumn } from "@sscs/ui";
import { PERMISSION, Permission } from "Constants";
import { useAllowedTo } from "Hooks";
import { SortMembers } from "../../types";

/**
 * Column definitions plus the role-permission set shared by the organization
 * members table and the per-group members table. The role label and the
 * `actions` visibility follow whether the table is group-scoped.
 */
export const useMembersColumns = (
  groupId?: string,
): {
  columns: DataTableColumn<SortMembers["property"]>[];
  permissions: Permission[];
} => {
  const permissions: Permission[] = groupId
    ? [
        PERMISSION.MODIFY_MEMBERS_ORGANIZATION_ROLE,
        PERMISSION.MODIFY_MEMBERS_GROUP_ROLE,
      ]
    : [PERMISSION.MODIFY_MEMBERS_ORGANIZATION_ROLE];

  const canModifyMembers = useAllowedTo({ permissions, groupId });

  const columns: DataTableColumn<SortMembers["property"]>[] = [
    { id: "name", label: "Name", sortProperty: "name", width: "50%" },
    { id: "email", label: "Email", sortProperty: "email", width: "50%" },
    {
      id: "role",
      label: `${groupId ? "Group" : "Organization"} Role`,
      width: "200px",
    },
    { id: "groups", label: "Groups", width: "250px" },
    { id: "lastActive", label: "Last active", width: "130px" },
    {
      id: "actions",
      label: "Actions",
      align: "center",
      width: "100px",
      hidden: !canModifyMembers,
    },
  ];

  return { columns, permissions };
};
